var _excluded = ["children"],
    _excluded2 = ["count", "wrapper", "className", "containerClassName", "containerTestId", "circle", "style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
/**
 * @internal
 */

var SkeletonThemeContext = React.createContext({});

function SkeletonTheme(_ref) {
  var {
    children
  } = _ref,
      styleOptions = _objectWithoutProperties(_ref, _excluded);

  return React.createElement(SkeletonThemeContext.Provider, {
    value: styleOptions
  }, children);
}
/* eslint-disable react/no-array-index-key */


var defaultEnableAnimation = true; // For performance & cleanliness, don't add any inline styles unless we have to

function styleOptionsToCssProperties(_ref2) {
  var {
    baseColor,
    highlightColor,
    width,
    height,
    borderRadius,
    circle,
    direction,
    duration,
    enableAnimation = defaultEnableAnimation
  } = _ref2;
  var style = {};
  if (direction === 'rtl') style['--animation-direction'] = 'reverse';
  if (typeof duration === 'number') style['--animation-duration'] = "".concat(duration, "s");
  if (!enableAnimation) style['--pseudo-element-display'] = 'none';
  if (typeof width === 'string' || typeof width === 'number') style.width = width;
  if (typeof height === 'string' || typeof height === 'number') style.height = height;
  if (typeof borderRadius === 'string' || typeof borderRadius === 'number') style.borderRadius = borderRadius;
  if (circle) style.borderRadius = '50%';
  if (typeof baseColor !== 'undefined') style['--base-color'] = baseColor;
  if (typeof highlightColor !== 'undefined') style['--highlight-color'] = highlightColor;
  return style;
}

function Skeleton(_ref3) {
  var {
    count = 1,
    wrapper: Wrapper,
    className: customClassName,
    containerClassName,
    containerTestId,
    circle = false,
    style: styleProp
  } = _ref3,
      propsStyleOptions = _objectWithoutProperties(_ref3, _excluded2);

  var _a, _b;

  var contextStyleOptions = React.useContext(SkeletonThemeContext); // Props take priority over context

  var styleOptions = _objectSpread(_objectSpread(_objectSpread({}, contextStyleOptions), propsStyleOptions), {}, {
    circle
  }); // `styleProp` has the least priority out of everything


  var style = _objectSpread(_objectSpread({}, styleProp), styleOptionsToCssProperties(styleOptions));

  var className = 'react-loading-skeleton';
  if (customClassName) className += " ".concat(customClassName);
  var inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
  var elements = []; // Without the <br />, the skeleton lines will all run together if
  // `width` is specified

  for (var i = 0; i < count; i++) {
    var skeletonSpan = React.createElement("span", {
      className: className,
      style: style,
      key: i
    }, "\u200C");

    if (inline) {
      elements.push(skeletonSpan);
    } else {
      elements.push(React.createElement(React.Fragment, {
        key: i
      }, skeletonSpan, React.createElement("br", null)));
    }
  }

  return React.createElement("span", {
    className: containerClassName,
    "data-testid": containerTestId,
    "aria-live": "polite",
    "aria-busy": (_b = styleOptions.enableAnimation) !== null && _b !== void 0 ? _b : defaultEnableAnimation
  }, Wrapper ? elements.map((el, i) => React.createElement(Wrapper, {
    key: i
  }, el)) : elements);
}

export { SkeletonTheme, Skeleton as default };